import common from "../../utill/Common";

class UtiPanCardService {
  report = async (
    token,
    from_date,
    to_date,
    status,
    user_id,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "admin/uti_pancard/report";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        search_text,
        status,
        user_id,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  summary = async (token, from_date, to_date) => {
    const url = common.baseUrl + "admin/uti_pancard/summary";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ from_date, to_date }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateTxnStatus = async (token, id, status, remark) => {
    const url = common.baseUrl + "admin/uti_pancard/update_txn_status";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id, status, remark }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  agentList = async (token, user_id, status, agent_id, page, size) => {
    const url = common.baseUrl + "admin/uti_pancard/agent_list";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        user_id,
        status,
        agent_id,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateAgent = async (token, id, status, agent_id, password, remark) => {
    const url = common.baseUrl + "admin/uti_pancard/update_agent";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id, status, agent_id, password, remark }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  v2Report = async (
    token,
    from_date,
    to_date,
    status,
    user_id,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/report";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        search_text,
        status,
        user_id,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  v2summary = async (token, from_date, to_date) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/summary";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ from_date, to_date }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  v2FetchById = async (token, id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/fetch_by_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  v2UpdatePANForm = async (token, order_id, panData) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/update_pan_form";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id, panData }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  v2downloadForm = async (token, order_id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/download_form";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  v2DownloadReceipt = async (token, order_id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/download_receipt";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  v2CrDownloadForm = async (token, order_id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/cr/download_form";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  v2CrDownloadReceipt = async (token, order_id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/cr/download_receipt";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  v2CrRehit = async (token, order_id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/cr/rehit";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        order_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  v2Rehit = async (token, order_id) => {
    const url = common.baseUrl + "admin/uti_pancard/v2/rehit";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        order_id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UtiPanCardService();
